/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EventInfoCard_eventInfo$ref = any;
type MediaList_media$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountEventPage_viewer$ref: FragmentReference;
declare export opaque type AccountEventPage_viewer$fragmentType: AccountEventPage_viewer$ref;
export type AccountEventPage_viewer = {|
  +event: ?{|
    +name: ?string,
    +products: ?$ReadOnlyArray<?{|
      +type: ?string
    |}>,
    +sgId: ?number,
    +shortName: ?string,
    +searchByFace: ?boolean,
    +$fragmentRefs: EventInfoCard_eventInfo$ref,
  |},
  +account: ?{|
    +event: ?{|
      +availableCertificates: ?$ReadOnlyArray<?string>,
      +availableVideos: ?$ReadOnlyArray<?string>,
      +availableZips: ?$ReadOnlyArray<?string>,
      +bonusMedia: ?{|
        +mediaInfo: ?{|
          +count: ?number
        |},
        +mediaList: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +sgId: ?number,
              +variants: ?$ReadOnlyArray<?{|
                +format: ?string,
                +name: ?string,
                +url: ?string,
              |}>,
            |}
          |}>,
          +$fragmentRefs: MediaList_media$ref,
        |},
      |},
      +canRestart: ?boolean,
      +participants: ?$ReadOnlyArray<?{|
        +media: ?{|
          +mediaInfo: ?{|
            +count: ?number
          |},
          +mediaList: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +sgId: ?number,
                +variants: ?$ReadOnlyArray<?{|
                  +format: ?string,
                  +name: ?string,
                  +url: ?string,
                |}>,
              |}
            |}>,
            +$fragmentRefs: MediaList_media$ref,
          |},
        |},
        +startnumber: ?string,
      |}>,
      +singleMedia: ?{|
        +mediaInfo: ?{|
          +count: ?number
        |},
        +mediaList: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +sgId: ?number,
              +variants: ?$ReadOnlyArray<?{|
                +format: ?string,
                +name: ?string,
                +url: ?string,
              |}>,
            |}
          |}>,
          +$fragmentRefs: MediaList_media$ref,
        |},
      |},
    |}
  |},
  +$refType: AccountEventPage_viewer$ref,
|};
export type AccountEventPage_viewer$data = AccountEventPage_viewer;
export type AccountEventPage_viewer$key = {
  +$data?: AccountEventPage_viewer$data,
  +$fragmentRefs: AccountEventPage_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mediaInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "MediaInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "count",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mediaList",
    "storageKey": "mediaList(first:1000)",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      }
    ],
    "concreteType": "MediaConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Media",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "variants",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "format",
                    "args": null,
                    "storageKey": null
                  },
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "MediaList_media",
        "args": null
      }
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "AccountEventPage_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "eventId",
      "type": "ID!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "event",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "eventId"
        }
      ],
      "concreteType": "Event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "products",
          "storageKey": null,
          "args": null,
          "concreteType": "Product",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            }
          ]
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shortName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchByFace",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "EventInfoCard_eventInfo",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "account",
      "storageKey": null,
      "args": null,
      "concreteType": "Account",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "event",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "byStartnumber",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "eventId",
              "variableName": "eventId"
            }
          ],
          "concreteType": "BoughtEvent",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "availableCertificates",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "availableVideos",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "availableZips",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "bonusMedia",
              "storageKey": null,
              "args": null,
              "concreteType": "ExtendedMediaConnection",
              "plural": false,
              "selections": (v2/*: any*/)
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "canRestart",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "participants",
              "storageKey": null,
              "args": null,
              "concreteType": "BoughtParticipant",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "media",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ExtendedMediaConnection",
                  "plural": false,
                  "selections": (v2/*: any*/)
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "startnumber",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "singleMedia",
              "storageKey": null,
              "args": null,
              "concreteType": "ExtendedMediaConnection",
              "plural": false,
              "selections": (v2/*: any*/)
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '8a686562b63e4e883535b53bb1021aee';

module.exports = node;
